module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.tournament) ? _c('div', [(_vm.tournament.regulations) ? _c('div', [_c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("Regulations")]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.tournament.regulations))])]) : _vm._e(), _vm._v(" "), (_vm.tournament.commments) ? _c('div', [_c('div', {
    staticClass: "md-subhead"
  }, [_vm._v("Comments")]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.tournament.comments))])]) : _vm._e()]) : _c('div', [_c('p', [_vm._v("Oops... no current tournament")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3279ea51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tournamentComponents/tournamentDetails.vue
// module id = 441
// module chunks = 1